// codegen:start {preset: barrel, include: './lib/*.{ts,tsx}', exclude: './lib/*.{test,spec}.{ts,tsx}'}
export * from './lib/use-tab-change'; // codegen:end